/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/training.scss";
import PopRegisterParticipant from "./_PopRegisterParticipant";

const TrainingAttendance = () => {
  const [modalRegisterParticipant, setModalRegisterParticipant] =
    useState(false);
  return (
    <main className="com_container com_training p_training_attendance">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_3 ">교사교육 출석부</h2>
          <button
            onClick={() => setModalRegisterParticipant(true)}
            className="com_btn orange s btn_plus"
          >
            참석자 등록
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="년 도 선택">년 도 선택</option>
                </select>
                <select className="select long">
                  <option value="교사교육 공고명 선택">
                    교사교육 공고명 선택
                  </option>
                </select>
              </div>
            </div>

            <div className="com_board_list__top">
              <div className="info_row ">
                <div className="info_value">
                  <div className="txt value">입사자 재교육</div>
                  <div className="txt value"> 홍길동103 교관</div>
                  <div className="txt value"> 12회/25회</div>
                  <div className="txt value"> (목) (금) 19 : 30</div>
                </div>
              </div>

              <div className="com_btn_wrap">
                <button className="btn btn_red">결석 : 45</button>
                <button className="btn btn_red">지각 : 10</button>
                <button className="btn btn_red">진행 : 45</button>
                <button className="btn btn_red">포기 : 10</button>
              </div>
            </div>

            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="35%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                  <col width="5%" />
                </colgroup>
                <thead>
                  <tr>
                    <th rowSpan="2">No.</th>
                    <th rowSpan="2">이름</th>
                    <th rowSpan="2">비고</th>
                    <th rowSpan="2">출석상태</th>
                    <th rowSpan="2">최종점수</th>
                    <th colSpan="8">출석부</th>
                  </tr>
                  <tr>
                    <th className="border_left">1회</th>
                    <th>2회</th>
                    <th>3회</th>
                    <th>4회</th>
                    <th>5회</th>
                    <th>6회</th>
                    <th>7회</th>
                    <th>8회</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>홍길동103</td>
                    <td>
                      <select className="select">
                        <option value="선택">선택</option>
                      </select>
                    </td>
                    <td>결석45 / 지각:12 / 조퇴12</td>
                    <td>
                      <select className="select">
                        <option value="선택">선택</option>
                      </select>
                    </td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>홍길동103</td>
                    <td className="td_red">포기</td>
                    <td>결석45 / 지각:12 / 조퇴12</td>
                    <td className="td_point">보통</td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>홍길동103</td>
                    <td className="td_point">진행</td>
                    <td>결석45 / 지각:12 / 조퇴12</td>
                    <td className="td_point">미비</td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>홍길동103</td>
                    <td className="td_point">진행</td>
                    <td>결석45 / 지각:12 / 조퇴12</td>
                    <td className="td_point">재교육</td>
                    <td>/</td>
                    <td>X</td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>홍길동103</td>
                    <td className="td_point">진행</td>
                    <td>결석45 / 지각:12 / 조퇴12</td>
                    <td className="td_point">보수교육</td>
                    <td>/</td>
                    <td>X</td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>홍길동103</td>
                    <td className="td_point">진행</td>
                    <td>결석45 / 지각:12 / 조퇴12</td>
                    <td className="td_point">재교육</td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>홍길동103</td>
                    <td className="td_point">진행</td>
                    <td>결석45 / 지각:12 / 조퇴12</td>
                    <td className="td_point">보수교육</td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <button className="circle" />
                    </td>
                    <td>
                      <select className="select">
                        <option value="/">/</option>
                      </select>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <div className="com_btn_wrap center">
                <button className="com_btn orange s wl">저장</button>
              </div>
            </div>
          </section>
          <div className="com_board_box">
            <div className="board_item">
              <div className="info">
                <span className="cont">
                  <span className="com_icon red">수업진행중</span>
                  <button className="name">홍길동103 </button>
                  <span className="date dot">2025, 05, 20 11 : 30</span>
                </span>
              </div>
            </div>
          </div>
          <div className="info_container">
            <section className="box box-half">
              <div className="com_board_box">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">교육</span>
                    <span className="cont com_blue_txt ">입사자 재교육</span>
                  </div>
                  <div className="info">
                    <span className="tit">교관</span>
                    <span className="cont bold">김교관103</span>
                  </div>
                  <div className="info">
                    <span className="tit">회차/시간</span>
                    <span className="cont">총16회 / 1회 90분</span>
                  </div>
                  <div className="info">
                    <span className="tit">기간</span>
                    <span className="cont">2023, 05, 16 ~ 2023, 06, 15</span>
                  </div>
                  <div className="info">
                    <span className="tit">등록 가능 인원</span>
                    <span className="cont">25명</span>
                  </div>
                  <div className="info">
                    <span className="tit">요일 시간</span>
                    <span className="cont">매주 월, 화, 금 16:30</span>
                  </div>

                  <div className="info">
                    <span className="tit">등록 마감일</span>
                    <span className="cont">2023, 05, 16</span>
                  </div>
                </div>
              </div>
            </section>
            <section className="box box-half">
              <div className="info_row">
                <div className="info_label">총 계약자</div>
                <div className="info_value">206명</div>
              </div>
              <div className="info_row">
                <div className="info_label">유지자</div>
                <div className="info_value">166명</div>
                <div className="info_label indent">수업진행률</div>
                <div className="info_value">43.70%</div>
              </div>
              <div className="info_row">
                <div className="info_label">
                  평균 10타임 이상
                  <br />
                  손실률{" "}
                </div>
                <div className="info_value">75% 이상</div>
              </div>
              <div className="info_row">
                <div className="info_label">우수 신규교사</div>
                <div className="info_value">22명 (14.56%)</div>
              </div>
              <div className="info_row">
                <div className="txt label">국어(2) :</div>
                <div className="txt value">문상연, 최선지</div>
                <div className="txt label">수학(3) :</div>
                <div className="txt value"> 조윤희, 명형환, 염우진</div>
                <div className="txt label">영어(5) :</div>
                <div className="txt value">
                  김경민, 윤수정, 전정호, 표성협, 우민호
                </div>
              </div>
              <div className="info_row">
                <div className="txt label">사탐(2) :</div>
                <div className="txt value"> 박찬, 전성식</div>
                <div className="txt label">과탐(4) :</div>
                <div className="txt value">고지연, 손세용, 장지영, 정윤제</div>
              </div>
            </section>
          </div>
        </section>
      </div>
      <PopRegisterParticipant
        open={modalRegisterParticipant}
        close={() => setModalRegisterParticipant(false)}
      />
    </main>
  );
};

export default TrainingAttendance;
